import { render, staticRenderFns } from "./dDialog.vue?vue&type=template&id=6c1ab073&scoped=true"
import script from "./dDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ab073",
  null
  
)

export default component.exports